"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=inferred-package-properties.js.map